module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/fr-card-drag.586e0612be0496ed3817.gif";